var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "card-body",
      attrs: { role: "form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onUpdateUserBasicInformation($event)
        }
      }
    },
    [
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.T.username))]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.username,
              expression: "username"
            }
          ],
          staticClass: "form-control",
          class: { "is-invalid": !_vm.isValidUsername },
          attrs: { "data-username": "" },
          domProps: { value: _vm.username },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.username = $event.target.value
            }
          }
        }),
        !_vm.isValidUsername
          ? _c("div", { staticClass: "invalid-feedback" }, [
              _vm._v(" " + _vm._s(_vm.T.parameterInvalidAlias) + " ")
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.T.wordsName))]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.name,
              expression: "name"
            }
          ],
          staticClass: "form-control",
          attrs: { "data-name": "" },
          domProps: { value: _vm.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.name = $event.target.value
            }
          }
        })
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.T.wordsGender))]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.gender,
                expression: "gender"
              }
            ],
            staticClass: "custom-select",
            attrs: { "data-gender": "" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.gender = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "female" } }, [
              _vm._v(_vm._s(_vm.T.wordsGenderFemale))
            ]),
            _c("option", { attrs: { value: "male" } }, [
              _vm._v(_vm._s(_vm.T.wordsGenderMale))
            ]),
            _c("option", { attrs: { value: "other" } }, [
              _vm._v(_vm._s(_vm.T.wordsGenderOther))
            ]),
            _c("option", { attrs: { value: "decline" } }, [
              _vm._v(_vm._s(_vm.T.wordsGenderDecline))
            ])
          ]
        )
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.T.wordsCountry))]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.countryId,
                expression: "countryId"
              }
            ],
            staticClass: "custom-select",
            attrs: { "data-countries": "" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.countryId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "" } }),
            _vm._l(_vm.countries, function(country) {
              return _c(
                "option",
                {
                  key: country.country_id,
                  domProps: { value: country.country_id }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        country.country_id === "xx"
                          ? _vm.T.countryNotSet
                          : country.name
                      ) +
                      " "
                  )
                ]
              )
            })
          ],
          2
        )
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.T.profileState))]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.stateId,
                expression: "stateId"
              }
            ],
            staticClass: "custom-select",
            attrs: { "data-states": "", disabled: !_vm.isCountrySelected },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.stateId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          _vm._l(Object.entries(_vm.countryStates), function(ref) {
            var code = ref[0]
            var state = ref[1]
            return _c(
              "option",
              { key: code, domProps: { value: code.split("-")[1] } },
              [_vm._v(" " + _vm._s(state.name) + " ")]
            )
          }),
          0
        )
      ]),
      _c(
        "div",
        { staticClass: "form-group", attrs: { "data-date-of-birth": "" } },
        [
          _c("label", [_vm._v(_vm._s(_vm.T.userEditBirthDate))]),
          _c("omegaup-datepicker", {
            attrs: { required: false, max: new Date() },
            model: {
              value: _vm.birthDate,
              callback: function($$v) {
                _vm.birthDate = $$v
              },
              expression: "birthDate"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "mt-3" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary mr-2",
            class: { disabled: !_vm.hasChanges },
            attrs: {
              type: "submit",
              "data-save-profile-changes-button": "",
              disabled: !_vm.hasChanges
            }
          },
          [_vm._v(" " + _vm._s(_vm.T.wordsSaveChanges) + " ")]
        ),
        _c(
          "a",
          { staticClass: "btn btn-cancel", attrs: { href: "/profile/" } },
          [_vm._v(_vm._s(_vm.T.wordsCancel))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }